import React from 'react'

const Formulario = () => {
    return (
        <>
            <div className="container my-4">
                <form>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                                <label htmlFor="nombre">Nombre</label>
                                <input type="text" className="form-control" id="nombre" placeholder="Nombre" required/>
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="inputEmail4">Correo</label>
                            <input type="email" className="form-control" id="inputEmail4" placeholder="abc@123.com" required/>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                                <label htmlFor="marca">Marca del automóvil</label>
                                <input type="text" className="form-control" id="marca" placeholder="Marca"/>
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="codigo">Código del producto</label>
                            <input type="number" className="form-control" id="codigo" placeholder="1234"/>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputAddress">Dirección</label>
                        <input type="text" className="form-control" id="inputAddress" placeholder=""/>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label htmlFor="inputCity">Departamento</label>
                            <input type="text" className="form-control" id="inputCity"/>
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="inputState">Municipio</label>
                            <select id="inputState" className="form-control">
                                <option defaultValue>Elegir...</option>
                                <option>San Pedro</option>
                                <option>Panajachel</option>
                                <option>Sololá</option>
                            </select>
                        </div>
                        <div className="form-group col-md-2">
                            <label htmlFor="inputZip">Código postal</label>
                            <input type="text" className="form-control" id="inputZip"/>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="gridCheck"/>
                            <label className="form-check-label" htmlFor="gridCheck" required>
                                Acepto los términos y condiciones.
                            </label>
                        </div>
                    </div>
                    <button type="submit" className="btn btn-danger">Recibir cotización</button>
                </form>
            </div>
        </>
        )
}

export default Formulario